module.exports = __webpack_public_path__ + "img/116028.36f97400.png";